export default "__VITE_ASSET__0Dl2uyRW__"